import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  get,
  sortBy,
  orderBy,
  sumBy,
} from 'lodash';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';

import { formatPrice, getOrderStatus, addTagValue } from 'helpers/utils';
import {
  injectIntl,
} from 'components';
import {
  compose,
  setDisplayName,
} from 'recompose';
import { connect } from 'react-redux';
import immutableToJS from 'helpers/immutableToJS';
import { selectState } from 'redux/selectors';
import InvoicePrint from './InvoicePrint';

class SalesOrdersPrint extends Component {
  static propTypes = {
    deliveryDate: PropTypes.string.isRequired,
    info: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),
    loading: PropTypes.bool.isRequired,
    formatMessage: PropTypes.func.isRequired,
    tags: PropTypes.arrayOf(PropTypes.shape({})),
  };

  static defaultProps = {
    info: [],
    tags: [],
  }

  static contextTypes = {
    currentUser: PropTypes.shape({}),
  };


  getOrders = () => {
    const { orders, deliveryDate } = this.props;
    const { isFarmer, isDistributor, currentUser } = this.context;
    let data = [];
    let filteredOrders = orders.filter(o => o.type != 'PO');
    let ordersWithoutZeroed = this.removeZeroedInvoices(filteredOrders);
    let sales = ordersWithoutZeroed;

    ordersWithoutZeroed.map((order, index) => {
      const allData = this.getData(order);
      let newAllData = [];

      if (order.createdAsDraft && isFarmer) {
        let parentOrderId = 0;
        allData.forEach((dataItem) => {
          if (dataItem.isParent && dataItem && (dataItem.quantity > 0 || dataItem.diff.indexOf('Reduce') >= 0 || dataItem.diff.indexOf('Increase') >= 0 ||
            (dataItem.editorId === currentUser.id && (dataItem.diff.indexOf('ordered') !== -1 || dataItem.qtyDiff === 0)))) {
            newAllData.push(dataItem);
            parentOrderId = Math.floor(dataItem.orderId);
          }
          if (!dataItem.isParent && dataItem.parentOrderId === parentOrderId && (dataItem.quantity > 0 || dataItem.diff.indexOf('Reduce') !== -1 || dataItem.diff.indexOf('Increase') !== -1)) {
            newAllData.push(dataItem);
          }
        });
      } else {
        newAllData = allData;
      }
      data = newAllData;
      sales[index]["data"] = data;
    });

    return sales;
  }

  removeZeroedInvoices = (orders) => {
    const filteredOrders = [];
    orders.forEach((order) => {
      if (order.orderItems){
        const filteredOrderItems =  order.orderItems.filter(item => item.quantity > 0);
        if (filteredOrderItems.length != 0){
          filteredOrders.push(order);
        }
      }
    });
    return filteredOrders;
  }

  getData = (order) => {
    const { isFarmer, isDistributor, currentUser } = this.context;
    const { tags } = this.props;
    const orderItemsWithDiff = [];
    if (order.orderActivities) {
      (orderBy(order.orderActivities, ['updatedAt'], ['desc'])).forEach((orderAct) => {
        if (orderAct.field === 'quantity') {
          orderItemsWithDiff.push({
            storeItemId: orderAct.orderItem.storeItemId,
            editorId: orderAct.editorId,
            editorMember: orderAct.editorMember,
          });
        }
      });
    }

    const orderItems = [];
    sortBy(order.orderItems || [], ['data.productData.category', 'data.productData.name', 'packrow.count'], ['asc', 'asc', 'asc']).forEach((orderItem) => {
      const qtyDiff = orderItem.quantity - orderItem.refundQuantity
        - sumBy(orderItem.children || [], row => row.quantity - row.refundQuantity);
      let diff = '';
      if (orderItem.children && orderItem.children.length && qtyDiff !== 0) {
        const orderItemsFilteredList = orderBy(orderItemsWithDiff, ['updatedAt'], ['desc']).filter(item => item.storeItemId === orderItem.storeItemId);
        const isUpdatedByDistributor = orderItemsFilteredList &&
          orderItemsFilteredList.length > 0 &&
          orderItemsFilteredList[0].editorId === currentUser.id &&
          !orderItemsFilteredList[0].editorId.editorMember ? 1 : 0;

        if (isDistributor) {
          diff = isUpdatedByDistributor ? `${qtyDiff > 0 ? 'Vendor must Reduce Qty by ' : 'Vendor must Increase Qty by '}${Math.abs(qtyDiff)}` : `${qtyDiff > 0 ? 'You must Increase Qty by' : 'You must Reduce Qty by '}${Math.abs(qtyDiff)}`;
        } else {
          diff = isUpdatedByDistributor ? `${qtyDiff > 0 ? 'Distributor must Increase Qty by ' : 'Distributor must Reduce Qty by '}${Math.abs(qtyDiff)}` : `${qtyDiff > 0 ? 'Reduce Qty by ' : 'Increase Qty by '}${Math.abs(qtyDiff)}`;
        }
      }
      const { packrow, orderId } = orderItem;
      orderItems.push({
        orderId,
        category: get(orderItem, 'data.productData.category'),
        cost: packrow.cost || 0,
        count: packrow.count,
        storeItemId: orderItem.storeItemId,
        parentOrderId: get(orderItem, 'parent.orderId'),
        parentOrderDiscount: get(orderItem, 'parent.order.discount'),
        customername: get(order, 'buyer.account.profile.companyName'),
        isParent: true,
        diff,
        className: 'bold',
        discount: get(order, 'discount'),
        discounted: (((packrow.price || 0) * (100 - (parseFloat(order.discount)))) / 100).toFixed(2),
        editable: order.type === 'SO' && !order.captured,
        editorId: get(orderItem, 'editorId'),
        editorMember: get(orderItem, 'editorMember'),
        editorMemberId: get(orderItem, 'editorMemberId'),
        finalUOM: `${packrow.count} ${packrow.uom} ${packrow.pack}`,
        id: get(orderItem, 'id'),
        name: get(orderItem, 'data.productData.name'),
        pack: packrow.pack || '',
        price: packrow.price || 0,
        qtyDiff,
        quantity: get(orderItem, 'quantity'),
        refundQuantity: get(orderItem, 'refundQuantity'),
        sourcename: get(orderItem, 'data.seller.companyName') || get(order, 'seller.account.profile.companyName'),
        status: getOrderStatus(order),
        subname: get(orderItem, 'data.productData.subname'),
        tags: get(orderItem, 'data.tags'),
        uom: packrow.uom || '',
        updatedAt: get(orderItem, 'updatedAt'),
        payMethod: order.payMethod,
        captureScheduledAt: get(order, 'captureScheduledAt'),
      });

      if (orderItem.children) {
        orderItem.children.forEach((child) => {
          orderItems.push({
            category: get(child, 'data.productData.category'),
            customername: get(child, 'order.buyer.account.profile.companyName'),
            isParent: false,
            diff: diff ? `(${get(child, 'quantity')} ${diff})` : `(ordered a qty of ${get(child, 'quantity')})`,
            className: 'normal',
            discount: get(child, 'discount'),
            editable: !get(child, 'order.captured') && !isFarmer,
            editorId: get(child, 'editorId'),
            editorMember: get(orderItem, 'editorMember'),
            editorMemberId: get(orderItem, 'editorMemberId'),
            hide: [
              'category',
              'name',
              'price',
              'price-based-discount',
              'priceTotal',
              'subname',
              'uom',
            ],
            id: get(child, 'id'),
            isChild: true,
            order: get(child, 'order'),
            orderId: get(child, 'order.id'),
            parentOrderId: orderId,
            price: child.packrow.price || 0,
            quantity: get(child, 'quantity'),
            refundEditable: !get(child, 'order.captured'),
            refundQuantity: get(child, 'refundQuantity'),
            status: child.order ? getOrderStatus(child.order) : '',
            payMethod: child.order ? child.order.payMethod : '',
            tags: get(child, 'data.tags'),
            updatedAt: get(child, 'updatedAt'),
            captureScheduledAt: get(child.order, 'captureScheduledAt'),
          });
        });
      }
    });
    //Remove items with quantity 0 from list to print
    const filteredOrderItems = orderItems.filter(item => item.quantity > 0);
    
    const categoryField = r => r.category;
    const sortedGroupItems = orderBy(
      addTagValue(filteredOrderItems, tags),
      [categoryField, 'tagValue'],
      ['asc', 'asc'],
    );
    return sortedGroupItems;
  }

  render() {
    const { deliveryDate, formatMessage, loading, info, orders } = this.props;
    const { currentUser } = this.context;

    const sales = this.getOrders();
    const salesHeader = `${formatMessage('Sales for')} ${moment(deliveryDate).format('LLLL')}`;
    const fieldsForSales = [
      {
        label: formatMessage('Customer'),
        name: 'buyer_business_name',
      },
      {
        className: 'highlight',
        colSpan: 3,
        label: formatMessage('IN'),
        name: 'item_name',
      },
      {
        label: formatMessage('UOM'),
        name: 'item_uom',
      },
      {
        label: formatMessage('Vendor'),
        name: 'source_business_name',
      },
      {
        label: formatMessage('Qty'),
        name: 'item_qty',
      },
      {
        className: 'bold',
        label: formatMessage('Price'),
        name: 'item_sell_price',
        render: row => (row.item_sell_price ? `$${formatPrice(row.item_sell_price)}` : ''),
      },
      {
        label: formatMessage('Total'),
        name: 'total_amount',
        render: row => (row.total_amount ? `$${formatPrice(row.total_amount)}` : ''),
      },
    ];
    return (
      <div className="purchase-orders-print">
        {
          loading && (
            <div className="print-progress">
              <CircularProgress />
            </div>
          )
        }
        {salesHeader ?
          (
            <div>
              <div>
                {salesHeader}
              </div>
              {
                sales.map(order => (
                  <InvoicePrint
                    key={order.id}
                    currentUser={currentUser}
                    fields={fieldsForSales}
                    formatMessage={formatMessage}
                    info={order}
                    data={order.data}
                  />
                ))
              }

            </div>
          ) : ''
        }
      </div>
    );
  }
}

// const wrappedSalesOrdersPrint = injectIntl(SalesOrdersPrint);
// wrappedSalesOrdersPrint.displayName = 'SalesOrdersPrint'

// export default wrappedSalesOrdersPrint;

const mapStateToProps = state => ({
  ...selectState('options', 'tags')(state, 'tags'),
});

export default compose(
  setDisplayName('SalesOrdersPrint'),
  connect(
    mapStateToProps,
  ),
  immutableToJS,
)(SalesOrdersPrint);